import { AbstractCommand } from 'src/models/command';

class DelayTheTaskOneDayCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_DelayTheTaskOneDay';

	public constructor(aggregateId: string) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
		};
	}
}

export { DelayTheTaskOneDayCommand };
